const wxBind = {
  name: 'wxBind',
  path: 'wxBind',
  component: resolve => require(['../../../pages/custom/wx-bind'], resolve)
}

export default wxBind
